import React from 'react'
import {Icon} from "./components/FormComps"
import './App.css'

export default function Page403() {

  return (
      <main>
        <div className="jumbotron m-3">
          <center>
            <h1 style={{fontSize: "4.0rem", color: "var(--color-danger)"}}><Icon name="forbidden"/></h1>
            <h1 style={{fontSize: "2.5rem", color: "var(--title-color)"}}>Access Denied</h1>
            <p className="lead" style={{color: "var(--label-color)"}}>
              You do not have permission to access the page you're looking for or your session has expired.<br/>
              <div className="d-flex flex-row justify-content-center gap-2 mt-4">
                <a className="btn btn-secondary mr-2" href="/">Home</a>
                <a className="btn btn-secondary" href="/signin">Sign in</a>
              </div>
            </p>
          </center>
        </div>
      </main>
    )
}
